export const SYNC_LOCK_STALE_MS = 10 * 60 * 1000;

export type SyncLockState = "inactive" | "active" | "stale";

export function classifySyncLock({
  status,
  startedAt,
  now = Date.now(),
}: {
  status?: string | null;
  startedAt?: string | null;
  now?: number;
}): SyncLockState {
  if (status !== "syncing") return "inactive";
  if (!startedAt) return "stale";

  const startedAtMs = Date.parse(startedAt);
  if (!Number.isFinite(startedAtMs)) return "stale";

  return now - startedAtMs >= SYNC_LOCK_STALE_MS ? "stale" : "active";
}
